<template>
  <div class="card-container channel">
    <el-card>
      <common-el-form
        :model="formModel"
        :rules="formRules"
        :submitData="submitData"
        @success="onSuccess"
        submit-btn-text="提交"
        failTitle="提交失败"
        loadingText="提交中..."
        :submitService="submitService"
        :showButton="false"
        :SubmitButton="true"
      >
        <div style="display: flex">
          <div>
            <el-form-item label="时间">
              <el-date-picker
                v-model="formModel.time"
                type="daterange"
                range-separator="至"
                :clearable="true"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
            <span>交易量：{{ tranSum / 100 || "暂未查询到交易量" }}</span>
          </div>
        </div>
      </common-el-form>
    </el-card>
  </div>
</template>

<script>
import CommonElForm from "components/common/CommonElForm";
import ElFormItem from "element-ui/packages/form/src/form-item";
import StatisticsService from "service/StatisticsService";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "shoptransactiontj",
  data() {
    return {
      formRules: {
        time: [
          {
            required: true,
            message: "请选择你要查寻的时间范围",
          },
        ],
      },
      formModel: {
        time: "",
      },
      tranSum: "",
    };
  },
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  components: {
    ElFormItem,
    CommonElForm,
  },
  computed: {
    submitData() {
      if (this.formModel.time == null || this.formModel.time == "") {
        this.formModel.time = [];
      }
      this.params = {};
      if (this.formModel.time.length) {
        this.params.startDate = this.formModel.time[0];
        this.params.endDate = this.formModel.time[1];
      }
      return this.params;
    },
    submitService() {
      return StatisticsService.shoptransactiontj;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  mounted() {},
  methods: {
    onSuccess(data) {
      this.doCheck(data, (res) => {
        this.tranSum = res.contents;
        this.showSuccess(res.respMsg);
      });
    },
    ...mapActions({}),
  },
};
</script>

<style scoped>
span {
  font-size: 17px;
  margin-bottom: 10px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/view/page/Statistics/ShopTransactionTj.vue